import { Offers } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';
import { ActionError } from '@dgx-pr-spa/shared/util';

export const loadOffers = createAction(
  '[View Offers] Load Offers',
  props<{ payload?: string }>()
);

export const loadOffersSuccess = createAction(
  '[View Offers] Load Offers Success',
  props<{ payload: Offers }>()
);

export const loadOffersFail = createAction(
  '[View Offers] Load Offers Fail',
  props<{ payload: ActionError }>()
);

export const resetOffers = createAction('[View Offers] Reset Offers');

export type OffersActions =
  | typeof loadOffers
  | typeof loadOffersSuccess
  | typeof loadOffersFail
  | typeof resetOffers;
